import React from "react";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { TSearchResult } from "../../model/SearchResponse";

import { Col, Descriptions, List, Row, Typography, Badge } from "antd";
import Link from "../../../core/ui/components/Link";
import moment from "moment";
import { DateFormats } from "../../../core/common/Constants";
import { PaperClipOutlined } from "@ant-design/icons";
import { IRouter } from "../../../runtime/Router";
import { htmlReplace } from "../../../util/ReactHelper";

const { Text, Paragraph } = Typography;

interface Props {
  translate: TTranslate;
  item: TSearchResult;
  showDetails(item: TSearchResult): any;
  router: IRouter;
  highlights?: any;
  onSelectIndex;
  currentLanguage?: string;
}
const CaseDecisionListItem: React.FC<Props> = ({
  item,
  translate,
  router,
  showDetails,
  highlights,
  onSelectIndex,
  currentLanguage
}: Props) => {
  const documentHiglight = highlights["attr_attachment_content"]?.[0];
  let summary = item.summary;
  if (currentLanguage) {
    let property = `summary_${currentLanguage}_s`;
    summary = item[property] ? item[property] : item.summary;
    summary = highlights[property]?.[0] ? highlights[property]?.[0] : summary;
  }

  return (
    <List.Item style={{ cursor: "pointer" }} className={"card-list-item"}>
      <Link
        path={`/case-decisions/${item.collection_item_id}/details`}
        router={router}
      >
        <Row>
          <Col xs={24} sm={24} className={"card-list-item-actions-top"}>
            <Badge
              count={translate(`search.collection.${item.collection}`)}
              className={"png-badge"}
            />
            <Badge
              count={translate(
                `editors.case_decisions.status_values.${item.status}`
              )}
              className={"png-badge"}
            />
          </Col>

          <Col xs={24} sm={24}>
            <Paragraph ellipsis={{ rows: 3 }}>
              {htmlReplace(summary, (tag, props) => {
                if (tag === "em") {
                  return <Text mark />;
                }
              })}
            </Paragraph>
            {documentHiglight && (
              <Paragraph ellipsis={{ rows: 1 }} italic>
                <PaperClipOutlined /> "
                {htmlReplace(documentHiglight, (tag, props) => {
                  if (tag === "em") {
                    return <Text mark />;
                  }
                })}
                "
              </Paragraph>
            )}
          </Col>

          <Col
            xs={24}
            sm={24}
            className={"card-list-item-decriptions"}
            onClick={() => showDetails(item)}
          >
            <Descriptions
              size={"small"}
              column={{ xs: 1, sm: 1, md: 1, lg: 4, xl: 4, xxl: 4 }}
            >
              <Descriptions.Item
                span={2}
                label={
                  <strong>
                    {translate("editors.case_decisions.organisation_name")}
                  </strong>
                }
              >
                {item.organisation_name}
              </Descriptions.Item>
              <Descriptions.Item
                span={1}
                label={
                  <strong>
                    {translate("editors.case_decisions.court_case_number")}
                  </strong>
                }
              >
                {item.court_case_number_ss}
              </Descriptions.Item>
              {item.decision_date_dt && (
                <Descriptions.Item
                  span={1}
                  label={
                    <strong>
                      {translate("editors.case_decisions.decision_date")}
                    </strong>
                  }
                >
                  {moment(item.decision_date_dt)?.format(DateFormats.DATE)}
                </Descriptions.Item>
              )}
              {item.attr_index_name?.length > 0 && (
                <Descriptions.Item
                  span={3}
                  labelStyle={{}}
                  label={
                    <strong>
                      {translate(
                        "search.case_decisions.index_data",
                        undefined,
                        item.attr_index_name?.length
                      )}
                    </strong>
                  }
                >
                  <Paragraph ellipsis={{ rows: 3 }}>
                    {item.attr_index_name?.map((name, index) => (
                      <span
                        key={`attr-index-name-${index}`}
                        onClick={() =>
                          onSelectIndex({ index: item.index_id_is[index] })
                        }
                      >
                        {index !== item.attr_index_name.length - 1
                          ? `${name}, `
                          : `${name}`}
                      </span>
                    ))}
                  </Paragraph>
                </Descriptions.Item>
              )}
            </Descriptions>
          </Col>
        </Row>
      </Link>
    </List.Item>
  );

  return <></>;
};

export default CaseDecisionListItem;
